import React, { Dispatch } from "react";
import { ActionType } from "./types";
import { SignedInDto } from "../../services/Auth/dto/signedIn.dto";

export type AuthStateType = {
  userInfo?: SignedInDto;
};

export type AuthActionType = {
  type: symbol;
  userInfo?: SignedInDto;
};

type AuthReducerType = React.Reducer<AuthStateType, AuthActionType>;

export type AuthDispatch = Dispatch<AuthActionType>;

const initialGetState: AuthStateType = {};

const allowedGroups = ["SuperModerator", "Moderator", "Sale", "HomeBuyer"];

export const Reducer: AuthReducerType = (state = initialGetState, action) => {
  let listGroups = [];
  let group;
  switch (action.type) {
    case ActionType.SetUserInfo:
      if (!action.userInfo) {
        throw new Error("User Info must not be null");
      }
      if (
        !action.userInfo.signInUserSession?.idToken.payload["cognito:groups"]
      ) {
        throw new Error("User Info must have user group");
      }

      listGroups =
        action.userInfo.signInUserSession.idToken.payload["cognito:groups"] ||
        [];
      listGroups.forEach((groupName: string) => {
        if (allowedGroups.includes(groupName)) {
          group = groupName;
        }
      });

      return {
        userInfo: {
          ...action.userInfo,
          group,
        },
      };
    case ActionType.Logout:
      return {};
    default:
      return state;
  }
};
